import React from "react";
import FooterShell from "../shared/FooterShell";
import { MobileFooterVariantProps } from "../shared/types";

/** Games compact — 5 tabs with in-bar Games chip, no Multi Markets */
const GamesFiveFooter = (props: Omit<MobileFooterVariantProps, "footerId">) => (
  <><style>
    {`
            @media (max-width: 768px) {
      #header2 .header .mobilemenu nav ul li.game-nav::before {
          background-repeat: no-repeat;
          background-size: 100% 100%;
          content: "";
          height: 6vw;
          pointer-events: none;
          position: absolute;
          top: -5.9vw;
          width: 100%;
          z-index: -1;
          left: 9vw;
      }
  }
  `}
  </style>
    <FooterShell {...props} footerId="games-five" /></>

);

export default GamesFiveFooter;
